import type { EmblaCarouselType, EmblaPluginType } from 'embla-carousel'

// How far (as a fraction of the scrollable range) the track must sit from an
// edge before that edge's arrow enables. Absorbs sub-pixel float noise.
const SCROLL_EDGE_EPSILON = 0.001

// Embla's canScrollPrev/canScrollNext compare snap *indexes*, so with
// `slidesToScroll > 1` + `dragFree` a free-scroll of less than a snap group
// never changes the selected snap and the web-ui arrow buttons stay disabled
// at the edges. Legacy swiper's isBeginning/isEnd are *position* based. This
// plugin overrides the two checks on the Embla API (which the web-ui Carousel
// calls on every scroll/select/settle) to match legacy.
export function positionBasedCanScroll(): EmblaPluginType {
  return {
    name: 'positionBasedCanScroll',
    options: {},
    init: (embla: EmblaCarouselType) => {
      // Single-snap lists (content fits the viewport) can't scroll at all —
      // scrollProgress() returns 0 there, which must not enable "next".
      embla.canScrollPrev = () => embla.scrollSnapList().length > 1 && embla.scrollProgress() > SCROLL_EDGE_EPSILON
      embla.canScrollNext = () => embla.scrollSnapList().length > 1 && embla.scrollProgress() < 1 - SCROLL_EDGE_EPSILON
    },
    destroy: () => {
      // No teardown: the overrides live on the Embla API instance, which the
      // carousel discards on destroy.
    },
  }
}
